/**
 * WAHA WebSocket runtime configuration (raw JSON over `wss://`).
 *
 * Endpoint: `wss://…/api/v1/ws/messages?token=&branch_code=&locale=`
 * Channels: `branch:{branchCode}` (session + booking/planning events)
 */

export const WAHA_SOCKET_RECONNECT_DELAY_MS = 2000;
export const WAHA_SOCKET_MAX_RECONNECT_ATTEMPTS = 5;
export const WAHA_SOCKET_HEALTH_CHECK_INTERVAL_MS = 20_000;
export const SOCKET_INVALIDATION_DEBOUNCE_MS = 1000;

/** Session / pairing status + booking realtime broadcasts. */
export function getWahaBranchChannel(branchCode: string): string {
  return `branch:${branchCode.trim()}`;
}

export function buildWahaSubscribeFrame(channel: string): string {
  return JSON.stringify({ type: 'subscribe', channel });
}

export function buildWahaUnsubscribeFrame(channel: string): string {
  return JSON.stringify({ type: 'unsubscribe', channel });
}

export function buildWahaUnsubscribeFramesForBranch(branchCode: string): string[] {
  return [buildWahaUnsubscribeFrame(getWahaBranchChannel(branchCode))];
}

export function buildWahaHealthFrame(): string {
  return JSON.stringify({ type: 'health' });
}
